export default "__VITE_ASSET__DSGReyt$__"